import React from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Login from "../../../../client/src/CoreModules/Login"

export default () => (
  <Switch>
    <Route exact={false} path="/login" render={() => <Login />} />
    <Route path="*">
      <Redirect
        to={`/login?refer=${window.location.pathname}${
          window.location.search.length
            ? `?${window.location.search.slice(1)}`
            : ""
        }`}
      />
    </Route>
  </Switch>
)
